import { type EditEmpresaInmobiliariaModel, type DetailEmpresaInmobiliariaModel, EstadoEmpresaAgentesEnum, FormaJuridicaEnum, type DireccionModel } from '@api/api';

export class EditEmpresaInmobiliaria implements EditEmpresaInmobiliariaModel {
    Id: string = '';
    Web: string = '';
    Documento: string = '';
    Telefono: string = '';
    RazonSocial: string = '';
    Email: string = '';
    FechaCreacion: Date = new Date();
    RedesSociales: string | null = null;
    Direccion: DireccionModel = {} as DireccionModel;
    Iban: string | null = null;
    FormaJuridica: FormaJuridicaEnum | null = null;
    PorcentajeIrpf: number | null = null;
    DiasAutofacturacion: Array<number> = [];
    ImagenB64: string | null = null;
    LogoPortalB64: string | null = null;
    DenoFactura: string = '';
    TieneWhitelistServicios: boolean = false;
    WhitelistServicios: Array<string> | null = null;
    MarcoComisiones: string | null = null;
    UsuarioResponsable: string | null = null;
    PuedeTramitarAgua: boolean = true;
    IdEstado?: EstadoEmpresaAgentesEnum;
    MotivoRechazo?: string | null;
    IdComercial: string | null = null;

    constructor(data?: Partial<EditEmpresaInmobiliaria>) {
        Object.assign(this, data);
    }

    public createFromDetailEmpresaInmobiliaria(empresaInmobiliaria: DetailEmpresaInmobiliariaModel): EditEmpresaInmobiliaria {
        Object.assign(this, empresaInmobiliaria);
        return this;
    }

}